import { render, staticRenderFns } from "./FieldPermissions.vue?vue&type=template&id=35875f10&"
import script from "./FieldPermissions.vue?vue&type=script&lang=ts&"
export * from "./FieldPermissions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports